import React from "react";
import { Cpu, Bot, Hammer, Bug, Play, Pause, ChevronRight } from "lucide-react";
import { AGENTS, useOmniCraftStore } from "./store";

const ICONS = { orchestrator: Cpu, architect: Bot, builder: Hammer, debugger: Bug };
const COLORS = {
  orchestrator: "text-cyan-300 bg-cyan-500/10 border-cyan-500/30",
  architect: "text-violet-300 bg-violet-500/10 border-violet-500/30",
  builder: "text-emerald-300 bg-emerald-500/10 border-emerald-500/30",
  debugger: "text-rose-300 bg-rose-500/10 border-rose-500/30",
};

const STATUS = {
  in_progress: "text-cyan-300",
  passed: "text-emerald-300",
  failed: "text-rose-300",
  queued: "text-white/40",
};

export default function AgentCommandCenter() {
  const swarm = useOmniCraftStore((s) => s.swarm);
  const setSwarmPaused = useOmniCraftStore((s) => s.setSwarmPaused);

  return (
    <div
      data-testid="omnicraft-swarm"
      className="border border-white/10 rounded-xl bg-white/[0.02] p-3 space-y-3"
    >
      <div className="flex items-center justify-between">
        <div className="text-[10px] uppercase tracking-wider text-white/50">Devin Swarm</div>
        <button
          data-testid="omnicraft-swarm-toggle"
          onClick={() => setSwarmPaused(!swarm.paused)}
          className="flex items-center gap-1.5 text-[11px] text-white/70 border border-white/10 rounded-md px-2 py-1 hover:bg-white/5"
        >
          {swarm.paused ? <Play size={11} /> : <Pause size={11} />}
          {swarm.paused ? "Resume" : "Pause"}
        </button>
      </div>

      <div className="grid grid-cols-4 gap-2">
        {AGENTS.map((a) => {
          const Icon = ICONS[a.id];
          const active = swarm.active === a.id;
          return (
            <div
              key={a.id}
              data-testid={`omnicraft-agent-${a.id}`}
              className={`rounded-lg border p-2 flex flex-col items-start gap-1 transition-all ${
                active
                  ? COLORS[a.id]
                  : "border-white/5 bg-white/[0.01] text-white/50"
              }`}
            >
              <div className="flex items-center gap-1.5">
                <Icon size={12} />
                <span className="text-[10px] uppercase font-semibold tracking-wider">
                  {a.label}
                </span>
              </div>
              <span className="text-[10px] font-mono opacity-80 truncate w-full">
                {a.tool}
              </span>
              {active && (
                <span className="text-[9px] uppercase text-white/40 mt-0.5">Active</span>
              )}
            </div>
          );
        })}
      </div>

      <div className="space-y-1 max-h-40 overflow-y-auto pr-1">
        {swarm.subtasks.length === 0 && (
          <div className="text-[11px] text-white/40 italic">Idle. Awaiting a prompt.</div>
        )}
        {swarm.subtasks.map((t) => (
          <div
            key={t.id}
            className="flex items-center gap-2 text-[11px] text-white/80"
          >
            <ChevronRight size={10} className={STATUS[t.status] || "text-white/40"} />
            <span className={`uppercase text-[9px] ${STATUS[t.status] || "text-white/40"}`}>
              {t.status}
            </span>
            <span
              className={`px-1.5 py-0.5 rounded text-[9px] uppercase ${
                COLORS[t.agent] || "text-white/60 bg-white/5 border border-white/10"
              }`}
            >
              {t.agent}
            </span>
            <span className="flex-1 truncate">{t.label}</span>
            {t.tool && (
              <span className="font-mono text-[10px] text-white/40">{t.tool}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
